import React from "react";
import "./Catagories.scss";
import MenuItem from "../../Components/Menu-item/Menu-item.component";

const Catagories = ({ history }) => {
  return (
    <div id="catagories" className="Catagories">
      <h1>Catagories We Offer</h1>

      <div className="cards">
        <div className="c1">
          <MenuItem
            onClick={() => history.push("/products/beds")}
            title="Beds"
            availability="Available"
            size="large"
            img="https://images.unsplash.com/photo-1603072387865-e48a022fc541?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
          />
          <MenuItem
            onClick={() => history.push("/products/mattress")}
            title="Mattress"
            availability="Available"
            size="large"
            img="https://images.unsplash.com/photo-1583535045024-e2479a694777?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1268&q=80"
          />
        </div>
        <div className="c2">
          <MenuItem
            onClick={() => history.push("/products/furniture")}
            title="Furniture"
            availability="Available"
            size="large"
            img="https://images.unsplash.com/photo-1538688525198-9b88f6f53126?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1267&q=80"
          />
          <MenuItem
            title="Electronics"
            availability="Coming Soon..."
            size="large"
            img="https://images.unsplash.com/photo-1498049794561-7780e7231661?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
          />
          <MenuItem
            title="Clothing"
            availability="Coming Soon..."
            size="large"
            img="https://images.unsplash.com/photo-1523381210434-271e8be1f52b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
          />
        </div>
      </div>
    </div>
  );
};

export default Catagories;
